// 忘记密码页面翻译
export default {
  title: "找回密码",
  subtitle: "请输入手机号并完成短信验证以重置密码",
  contactServiceText: "账号登录用户忘记密码请",
  contactService: "联系客服",
  sendCode: "发送验证码",
  sendCodeAgain: "重新发送",
  backToLogin: "返回登录",
  nextStep: "下一步",
  resetPassword: "重置密码",
  resetSuccess: "密码重置成功",
  resetFailed: "密码重置失败",
  codeExpired: "验证码已过期",
  countdown: "{seconds}秒后重新发送",
  form: {
    codeRequired: "请先获取验证码",
    confirmNewPasswordRequired: "请再次确认新密码",
    passwordMismatch: "两次输入的密码不一致",
  },
  buttons: {
    getCaptcha: "获取验证码",
    confirm: "确认",
    cancel: "返回",
  },
  steps: {
    step1: "输入邮箱",
    step2: "验证身份",
    step3: "设置新密码",
  },
};
